import React, { useRef, forwardRef, useEffect } from 'react';
import Card from '../../Cards/ServiceCard/ServiceCard';
import { useSelectedServices } from './SelectedServicesContext';
import './servicesSection.css';
import { useBottomSheet } from '../../Modals/BottomSheet/BottomSheetContext';
import BottomSheet from '../../Modals/BottomSheet/BottomSheet';
import { animateServiceCards } from './ServicesSectionAnimation';

const Services = forwardRef(function Services({ services, pill, selectedService, setSelectedService }, ref) {
  const gridRef = useRef(null);
  const { selectedServices, addService, removeService } = useSelectedServices();
  const { isOpen, setIsOpen, closeBottomSheet, setCurrentService } = useBottomSheet();

  useEffect(() => {
    if (gridRef.current) {
      animateServiceCards(gridRef);
    }
  }, []);

  useEffect(() => {
    if (selectedService) {
      setCurrentService(selectedService);
      setIsOpen(true);
    }
  }, [selectedService, setCurrentService, setIsOpen]);

  const onCardClick = (service) => {
    setSelectedService(service);
  };

  const onServiceSelect = (serviceText) => {
    if (selectedServices.includes(serviceText)) {
      removeService(serviceText);
    } else {
      addService(serviceText);
    }
    closeBottomSheet();
  };

  const handleCloseBottomSheet = () => {
    setIsOpen(false);
    setSelectedService(null);
  };

  return (
    <div className="services-container" ref={ref}>
      <div className="grid grid--4" ref={gridRef}>
        {services.map((service, index) => (
          <Card
            key={index}
            imageSrc={service.imageSrc}
            text={service.text}
            description={service.description}
            pill={service.pill}
            onClick={() => onCardClick(service)}
            isSelected={selectedServices.includes(service.text)}
          />
        ))}
      </div>
      <BottomSheet
        isOpen={isOpen}
        onClose={handleCloseBottomSheet}
        service={selectedService}
        onServiceSelect={onServiceSelect}
      />
    </div>
  );
});

export default Services;
